import { render } from "./ContentCategories.vue?vue&type=template&id=064833c2"
import script from "./ContentCategories.vue?vue&type=script&lang=js"
export * from "./ContentCategories.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__